"use strict";
// const TweenMax = require("./TweenMax.min.js");
// const bubble = require("./bubble.js");
import smoothscroll from 'smoothscroll-polyfill';
import { timeout } from 'q';
import { setTimeout } from 'timers';
import { resolve } from 'url';
import { rejects } from 'assert';

//breakpoints
const breakpoints = matchMedia('(max-width:639px)').matches;

/*
* Hamburger Menu
 */
document.addEventListener("DOMContentLoaded", function () {
  var toggleButton = document.querySelector('.menu-toggle');
  var oldWidth = document.body.clientWidth;
  var mainContent = document.querySelector('#main');
  var root = document.querySelector('html,body');
  var scrollbarWidth = window.innerWidth - document.body.scrollWidth;
  var menuBody = document.querySelector('.menu-inner');
  //var menuParts = document.querySelectorAll('.menu-item,.menu-item > a')
  if (menuBody !== null) {
    menuBody.scrollTop = 1;
  }

  var movefun = function (e) {
    if (menuBody.scrollTop !== 0 && menuBody.scrollTop + menuBody.clientHeight !== menuBody.scrollHeight) {
      e.stopPropagation();
    }
    else {
      e.preventDefault();
    }
  }

  if (toggleButton !== null) {
    toggleButton.addEventListener('click', function () {

      if (scrollbarWidth) {
        // その分padding-rightを追加
        document.querySelector('html').style.paddingRight = scrollbarWidth + "px";
      }

      if (document.body.classList.contains('open')) {
        var currentPos = window.pageYOffset || document.documentElement.scrollTop;
        mainContent.classList.remove('hidden');
        toggleButton.classList.remove('open');
        document.body.classList.remove('open');
        root.setAttribute('style', '');
        window.removeEventListener('touchmove', movefun, { passive: false });
      } else {
        var currentPos = window.pageYOffset || document.documentElement.scrollTop;
        mainContent.classList.add('hidden');
        toggleButton.classList.add('open');
        document.body.classList.add('open');
        root.style.overflow = "hidden";
        window.addEventListener('touchmove', movefun, { passive: false });
      }
    });
  }
});


/*
* SlideIn
 */
document.addEventListener("DOMContentLoaded", function () {
  function slideIn() {
    //var scroll = this.scrollTop();
    var scroll = document.documentElement.scrollTop || document.body.scrollTop;
    var windowHeight = window.innerHeight;
    var slideinItems = document.querySelectorAll('.js-slidein');

    for (var i = 0; i < slideinItems.length; i++) {
      //var elemPos = this.offset().top;

      var slideinItem = slideinItems[i];
      var rect = slideinItem.getBoundingClientRect();
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var elemPos = rect.top + scrollTop;
      var offset = windowHeight / 4;

      if (scroll > elemPos - windowHeight + offset) {
        slideinItem.classList.add('js-slidein-active');
      }
    }
  }
  slideIn();
  window.addEventListener('scroll', function () {
    slideIn();
  });
});

/**
 * Smooth Scroll
 */
document.addEventListener('DOMContentLoaded', function () {
  function smoothLink(headH = 0) {
    const interval = 10;  //スクロール処理を繰り返す間隔
    const divisor = 8;  //近づく割合（数値が大きいほどゆっくり近く）
    const range = (divisor / 2) + 1;  //どこまで近づけば処理を終了するか(無限ループにならないように divisor から算出)
    const links = document.querySelectorAll('a[href^="#"]');

    for (let i = 0; i < links.length; i++) {
      links[i].addEventListener('click', function (e) {
        e.preventDefault();
        let toY;
        let nowY = window.pageYOffset;                       //現在のスクロール値
        const href = e.target.getAttribute('href');          //href取得
        const target = document.querySelector(href);         //リンク先の要素（ターゲット）取得
        const targetRect = target.getBoundingClientRect();   //ターゲットの座標取得
        const targetY = targetRect.top + nowY - headH;        //現在のスクロール値 & ヘッダーの高さを踏まえた座標
        //スクロール終了まで繰り返す処理
        (function doScroll() {
          toY = nowY + Math.round((targetY - nowY) / divisor);  //次に移動する場所（近く割合は除数による。）
          window.scrollTo(0, toY);                              //スクロールさせる
          nowY = toY;                                           //nowY更新

          if (document.body.clientHeight - window.innerHeight < toY) {
            //最下部にスクロールしても対象まで届かない場合は下限までスクロールして強制終了
            window.scrollTo(0, document.body.clientHeight);
            return;
          }
          if (toY >= targetY + range || toY <= targetY - range) {
            //+-rangeの範囲内へ近くまで繰り返す
            window.setTimeout(doScroll, interval);
          } else {
            //+-range の範囲内にくれば正確な値へ移動して終了。
            window.scrollTo(0, targetY);
          }
        })();
      });
    }
  };
  function backtoTop() {
    const totopButton = document.querySelector('.totop');
    if (totopButton !== null) {
      window.addEventListener('scroll', function () {
        let nowPos = window.pageYOffset || document.documentElement.scrollTop;
        //console.log(nowPos);
        if (nowPos > 0) {
          totopButton.classList.add('visible');
        } else {
          totopButton.classList.remove('visible');
        }
      });
      totopButton.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      });
    }
  };
  //関数実行
  if (breakpoints) {
    smoothLink(70);
  } else {
    smoothLink(80);
  }
  backtoTop();
});
//polyfill
smoothscroll.polyfill();

/**
 * Modal Popup
 */
document.addEventListener('DOMContentLoaded', function () {
  const actBtns = document.querySelectorAll('.js-btn-act');
  const overLays = document.querySelectorAll('.overlay');
  const closeBtns = document.querySelectorAll('.btn-close');
  const scrollbarWidth = window.innerWidth - document.body.scrollWidth;

  for (let i = 0; i < actBtns.length; i++) {
    actBtns[i].addEventListener('click', function (e) {
      e.preventDefault();
      overLays[i].classList.add('fixed');
      document.querySelector('html').classList.add('open');
      if (scrollbarWidth) {
        document.querySelector('html').style.paddingRight = scrollbarWidth + "px";
      }
    });

    closeBtns[i].addEventListener('click', function (e) {
      e.preventDefault();
      overLays[i].classList.remove('fixed');
      document.querySelector('html').classList.remove('open');
      document.querySelector('html').style.paddingRight = "0px";
    });
  }
});

/**
 * sign replace
 */
document.addEventListener('DOMContentLoaded', function () {
  const replaceSign = () => {
    if (!breakpoints) {
      const targetElem = document.querySelectorAll('.mes_visual__sign');
      const replaceToElem = document.querySelectorAll('.mes_visual');
      for (let i = 0; i < targetElem.length; i++) {
        const element = targetElem[i];
        replaceToElem[i].appendChild(element);
      }
    }
  }
  replaceSign();
  window.addEventListener('resize', replaceSign);
});

/**
 * picts replace
 */
document.addEventListener('DOMContentLoaded', function () {
  const replaceFunc = () => {
    if (breakpoints) {
      const targetElem = document.querySelectorAll('.line:not(.line01):not(.line09)');
      const replaceToElem = document.querySelectorAll('.sec');
      for (let i = 0; i < targetElem.length; i++) {
        const element = targetElem[i];
        replaceToElem[i].appendChild(element);
      }
    }
  }
  replaceFunc();
  window.addEventListener('resize', replaceFunc);
});

/**
 * Animated
 */
document.addEventListener('DOMContentLoaded', function () {
  const windowHeight = window.innerHeight;
  const offset = windowHeight / 2;

  const animFunc = () => {
    const lines = document.querySelectorAll('.line');
    let scroll = document.documentElement.scrollTop || document.body.scrollTop;
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    for (let i = 0; i < lines.length; i++) {
      let line = lines[i];
      //let animElm = animElms[i];
      let rect = line.getBoundingClientRect();
      let elemPos = rect.top + scrollTop;
      let picts = line.children;
      if (scroll + offset > elemPos) {
        for (let index = 0; index < picts.length; index++) {
          let pict = picts[index];
          setTimeout(() => {
            pict.classList.add('animated');
          }, 150 * index);
        }
      }
    }
  }

  const openAnim = () => {
    const animElms = document.querySelectorAll('.anim');
    for (let index = 0; index < animElms.length; index++) {
      let animElm = animElms[index];
      setTimeout(() => {
        animElm.classList.add('animated');
      }, 500 * index);
    }
  }

  const fadeAnim = () => {
    const sections = document.querySelectorAll('.sec');
    let scroll = document.documentElement.scrollTop || document.body.scrollTop;
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    for (let i = 0; i < sections.length; i++) {
      let sec = sections[i];
      let rect = sec.getBoundingClientRect();
      let animElms = sec.children;
      let elemPos = rect.top + scrollTop;
      if (scroll + offset > elemPos) {
        for (let index = 0; index < animElms.length; index++) {
          const animElm = animElms[index];
          setTimeout(() => {
            if (animElm.classList.contains('fade')) {
              animElm.classList.add('animated');
            }
          }, 150 * index);
        }
      } else {
        for (let i = 0; i < animElms.length; i++) {
          const animElm = animElms[i];
          setTimeout(() => {
            if (animElm.classList.contains('fade')) {
              animElm.classList.remove('animated');
            }
          }, 150 * i);
        }
      }
    }
  }

  fadeAnim();
  window.addEventListener('scroll', fadeAnim);

  const promise = new Promise((resolve, reject) => {
    resolve();
  });
  promise.then(() => {
    return new Promise((resolve, reject) => {
      openAnim();
      const animElm = document.querySelector('.anim:last-of-type');
      if (animElm !== null) {
        animElm.addEventListener('transitionend', () => {
          resolve();
        })
      } else {
        reject();
      }
    });
  }).then(() => {
    animFunc();
    window.addEventListener('scroll', animFunc);
  }).catch(() => {
    //console.log('animation element none');
    animFunc();
    window.addEventListener('scroll', animFunc);
  });
});

/**
 * kol signature replace for mobile devices
 */
document.addEventListener('DOMContentLoaded', function () {
  const replaceFunc = function () {
    let signs = document.querySelectorAll('.mes_visual__sign');
    for (let i = 0; i < signs.length; i++) {
      const element = signs[i];
      const parentElm = element.parentNode;
      parentElm.appendChild(element);
    }
  }
  if (breakpoints) {
    replaceFunc();
  }
});